// The query part that names a user by email, `email=<address>`, with the
// address encoded so a "+", "&", "#" or space reaches the admin intact
// (Django's request.query_params decodes it back). Every call that puts an
// email in a query string uses it; __tests__/emailQueryGuard.test.js checks.
//
// Pure. encodeURIComponent, not URLSearchParams: a space goes as %20, never
// "+", and null or undefined still go as the text "null" or "undefined".
export function emailQuery(email) {
  return `email=${encodeURIComponent(email)}`;
}
